import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Watermark } from '@/components/protection/Watermark';
import { useContainerFullscreen } from '@/hooks/useContainerFullscreen';
import { cn } from '@/lib/utils';

/**
 * Видео файлом (свои ролики из хранилища, 30.09.2026: на копии прода 19 блоков из 1447).
 *
 * ⚠️ nofullscreen У РОДНЫХ КНОПОК — ПРОДОЛЖЕНИЕ ЗАЩИТЫ ВОДЯНОГО ЗНАКА. В родном полном экране
 * браузер показывает сам ролик, и знак пропадает ровно там, где нужен. Chrome и Edge подсказку
 * слушают, Safari — нет (на маке родная кнопка останется).
 *
 * Разворот — НАШЕЙ кнопкой, контейнером со знаком внутри, тем же хуком, что у плеера YouTube
 * (hooks/useContainerFullscreen.ts). До 30.09.2026 у видео файлом на телефоне разворота не было
 * вовсе: родной отобран ради знака, своего не было.
 *
 * Отдельным файлом, а не внутри blockRenderers.tsx: там каждый новый компонент рядом с
 * не-компонентами даёт предупреждение линтера (fast refresh), а порог предупреждений зафиксирован.
 */
export function FileVideo({ url }: { url: string }) {
  const { t } = useTranslation();
  const shellRef = useRef<HTMLDivElement>(null);
  const { expanded, isFullscreen, rotated, toggle } = useContainerFullscreen(shellRef);
  const full = expanded || isFullscreen;
  return (
    <div
      ref={shellRef}
      // yt-shell — то же правило :fullscreen в index.css, что у плеера YouTube.
      className={cn(
        'yt-shell relative w-full overflow-hidden bg-black',
        expanded ? (rotated ? 'fixed z-[70] rounded-none' : 'fixed inset-0 z-[70] h-full rounded-none') : 'rounded-card',
      )}
      style={rotated}
    >
      <Watermark className={cn('w-full', full && 'h-full')}>
        <video
          src={url}
          controls
          // Без него iPhone открывает ролик своим системным плеером при первом же «играть»: ни знака, ни нашего
          // слоя — и закрывается он при любой перерисовке урока (01.10.2026).
          playsInline
          controlsList="nodownload noplaybackrate nofullscreen"
          disablePictureInPicture
          onContextMenu={(e) => e.preventDefault()}
          className={cn('block w-full', full ? 'h-full object-contain' : 'rounded-card')}
        />
      </Watermark>
      <button
        type="button"
        onClick={toggle}
        aria-label={t('blockRenderers.videoFullscreen')}
        className="absolute right-2 top-2 z-20 grid h-10 w-10 place-items-center rounded-full bg-black/55 text-white transition hover:bg-black/70"
      >
        <span className="material-symbols-outlined text-[22px]">{full ? 'fullscreen_exit' : 'fullscreen'}</span>
      </button>
    </div>
  );
}
